import AdminRolesComponent from './components/pages/technical/AdminRolesComponent';

require('./bootstrap');

import { createApp } from 'vue';

import vuetify from './vuetify';

import store from '../../store';

import globalMethods from './plugins/global-methods';

import DashboardComponent from './components/pages/DashboardComponent.vue';
import NavigationComponent from './components/NavigationComponent.vue';
import HeaderComponent from './components/HeaderComponent.vue';
import ClientComponent from './components/pages/organizational/ClientComponent';
import ClientEditComponent from './components/pages/organizational/Client/ClientEditComponent.vue';
import ClientCreateComponent from './components/pages/organizational/Client/ClientCreateComponent.vue';
import LoginComponent from './components/login/LoginComponent';
import AdminUsersComponent from './components/pages/organizational/AdminUsersComponent';
import GrattersListComponent from './components/pages/organizational/Gratters/GrattersListComponent';
import GrattersCreateComponent from './components/pages/organizational/Gratters/GrattersCreateComponent';
import GrattersDetailComponent from './components/pages/organizational/Gratters/GrattersDetailComponent';
import GroupRightComponent from './components/pages/technical/AdminRole/GroupRightComponent';
import OrganizationComponent from './components/pages/organizational/OrganizationComponent';
import OrganizationCreateComponent from './components/pages/organizational/Organization/OrganizationCreateComponent';
import BrandComponent from './components/pages/organizational/BrandComponent';
import BrandCreateComponent from './components/pages/organizational/Brand/BrandCreateComponent';
import RegionComponent from './components/pages/dictionary/RegionComponent';
import RegionCreateComponent from './components/pages/dictionary/Region/RegionCreateComponent';
import CityComponent from './components/pages/dictionary/CityComponent';
import CityCreateComponent from './components/pages/dictionary/City/CityCreateComponent';
import AddressComponent from './components/pages/organizational/AddressComponent';
import AddressCreateComponent from './components/pages/organizational/Address/AddressCreateComponent';
import DeviceTypeComponent from './components/pages/technical/DeviceTypeComponent';
import DeviceTypeCreateComponent from './components/pages/technical/DeviceType/DeviceTypeCreateComponent';
import WorktimeComponent from './components/pages/dictionary/WorktimeComponent';
import WorktimeCreateComponent from './components/pages/dictionary/Worktime/WorktimeCreateComponent';
import DeviceComponent from './components/pages/organizational/DeviceComponent';
import DeviceCreateComponent from './components/pages/organizational/Device/DeviceCreateComponent';
import LicenseComponent from './components/pages/documents/License/LicenseComponent';
import LicenseCreateComponent from './components/pages/documents/License/LicenseCreateComponent';
import RepositoryComponent from './components/pages/technical/RepositoryComponent';
import RepositoryCreateComponent from './components/pages/technical/Repository/RepositoryCreateComponent';
import TypographyComponent from './components/pages/typography/TypographyComponent.vue';
import ContentComponent from './components/pages/clients/ContentComponent';
import ContentCreateComponent from './components/pages/clients/Content/ContentCreateComponent';
import PlaylistComponent from './components/pages/clients/PlaylistComponent';
import PlaylistCreateComponent from './components/pages/clients/Playlist/PlaylistCreateComponent';
import GroupComponent from './components/pages/clients/GroupComponent';
import GroupCreateComponent from './components/pages/clients/Group/GroupCreateComponent';
import PlaylistContentComponent from './components/pages/clients/Playlist/PlaylistContentComponent';
import GroupDeviceComponent from './components/pages/clients/Group/GroupDeviceComponent';
import GroupPlaylistComponent from './components/pages/clients/Group/GroupPlaylistComponent';
import DeviceEditComponent from './components/pages/organizational/Device/DeviceEditComponent';
import AddressEditComponent from './components/pages/organizational/Address/AddressEditComponent';
import OrganizationEditComponent from './components/pages/organizational/Organization/OrganizationEditComponent';
import ContentEditComponent from './components/pages/clients/Content/ContentEditComponent';
import PlaylistEditComponent from './components/pages/clients/Playlist/PlaylistEditComponent';
import BrandEditComponent from './components/pages/organizational/Brand/BrandEditComponent';
import LicenseEditComponent from './components/pages/documents/License/LicenseEditComponent';
import AccountCreateComponent from './components/pages/documents/License/AccountCreateComponent.vue';
import FooterComponent from './components/FooterComponent';
import ContentTableComponent from './components/pages/clients/Content/ContentTableComponent';
import ContentTableRowComponent from './components/pages/clients/Content/ContentTableRowComponent';
import _ from 'lodash';
import PlaylistDevicesComponent from './components/pages/clients/Playlist/PlaylistDevicesComponent';
import ContentInfoComponent from './components/pages/clients/Content/ContentInfoComponent';
import NotificationsComponent from './components/pages/organizational/NotificationsComponent';
import NotificationsCreateComponent from './components/pages/organizational/Notifications/NotificationsCreateComponent';
import NotificationsEditComponent from './components/pages/organizational/Notifications/NotificationsEditComponent';
import NotificationComponent from './components/pages/clients/NotificationComponent';
import NotificationDetailComponent from './components/pages/clients/Notification/NotificationDetailComponent';
import LetterConstructorComponent from './components/pages/technical/LetterConstructorComponent';
import MailingAddComponent from './components/pages/technical/Mailings/MailingAddComponent.vue';
import MailingEditComponent from './components/pages/technical/Mailings/MailingEditComponent.vue';
import MailingRegistryComponent from './components/pages/technical/Mailings/MailingRegistryComponent.vue';
import RecieversGroupAddComponent from './components/pages/technical/Mailings/RecieversGroupAddComponent.vue';
import RecieversGroupComponent from './components/pages/technical/Mailings/RecieversGroupComponent.vue';
import RecieversGroupEditComponent from './components/pages/technical/Mailings/RecieversGroupEditComponent.vue';
import TemplateAddComponent from './components/pages/technical/Mailings/TemplateAddComponent.vue';
import TemplateEditComponent from './components/pages/technical/Mailings/TemplateEditComponent.vue';
import TemplateRegistryComponent from './components/pages/technical/Mailings/TemplateRegistryComponent.vue';
import SendersComponent from './components/pages/technical/Mailings/SendersComponent.vue';
import SendersAddComponent from './components/pages/technical/Mailings/SendersAddComponent.vue';
import SendersEditComponent from './components/pages/technical/Mailings/SendersEditComponent.vue';
import DevicesListClientComponent from './components/pages/clients/Devices/DevicesListClientComponent.vue';
import LogComponent from './components/pages/technical/Logs/LogComponent.vue';
import LogHardwareComponent from './components/pages/technical/Logs/LogHardwareComponent.vue';
import LogSoftwareComponent from './components/pages/technical/Logs/LogSoftwareComponent.vue';
import LogInstallUpdatesComponent from './components/pages/technical/Logs/LogInstallUpdatesComponent.vue';
import LogEventsComponent from './components/pages/technical/Logs/LogEventsComponent.vue';
import LogScheduleUpdateComponent from './components/pages/technical/Logs/LogScheduleUpdateComponent.vue';
import LogDownloadsUpdatesComponent from './components/pages/technical/Logs/LogDownloadsUpdatesComponent.vue';
import LogContentUpdateComponent from './components/pages/technical/Logs/LogContentUpdateComponent.vue';
import NotificationRegistryComponent from './components/pages/technical/Notification/NotificationRegistryComponent.vue';
import NotificationAddComponent from './components/pages/technical/Notification/NotificationAddComponent.vue';
import NotificationEditComponent from './components/pages/technical/Notification/NotificationEditComponent.vue';
import NotificationListComponent from './components/pages/clients/Notification/NotificationListComponent.vue';
// import vSelect from 'vue-select';
import Slider from '@vueform/slider';
import VersionRegistryComponent from './components/pages/technical/Versions/VersionRegistryComponent.vue';
import VersionAddComponent from './components/pages/technical/Versions/VersionAddComponent.vue';
import VersionEditComponent from './components/pages/technical/Versions/VersionEditComponent.vue';
import ContentCheckComponent from './components/pages/organizational/ContentCheckComponent.vue'
import ScheduleComponent from './components/pages/technical/Schedule/ScheduleComponent.vue';
import SoftwareUpdateScheduleComponent from './components/pages/technical/Schedule/SoftwareUpdateScheduleComponent.vue';
import ContentUpdateScheduleComponent from './components/pages/technical/Schedule/ContentUpdateScheduleComponent.vue';
import AddSoftwareUpdateScheduleComponent from './components/pages/technical/Schedule/AddSoftwareUpdateScheduleComponent.vue';
import EditSoftwareUpdateScheduleComponent from './components/pages/technical/Schedule/EditSoftwareUpdateScheduleComponent.vue';
import AddContentUpdateScheduleComponent from './components/pages/technical/Schedule/AddContentUpdateScheduleComponent.vue';
import ReleaseRegistryComponent from './components/pages/technical/Releases/ReleaseRegistryComponent.vue';
import ReleaseAddComponent from './components/pages/technical/Releases/ReleaseAddComponent.vue';
import ReleaseEditComponent from './components/pages/technical/Releases/ReleaseEditComponent.vue';
import DeviceSoftwareComponent from './components/pages/technical/DevicesSoftware/DeviceSoftwareComponent.vue';
import DeviceSoftwareCreateComponent from './components/pages/technical/DevicesSoftware/DeviceSoftwareCreateComponent.vue';
import DeviceSoftwareEditComponent from './components/pages/technical/DevicesSoftware/DeviceSoftwareEditComponent.vue';
import DeviceStatusComponent from "./components/pages/technical/Releases/DeviceStatusComponent.vue";


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
/* import specific icons */
import { faLocation } from '@fortawesome/free-solid-svg-icons';
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faSmile } from '@fortawesome/free-regular-svg-icons';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faTabletScreenButton } from '@fortawesome/free-solid-svg-icons';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faCity } from '@fortawesome/free-solid-svg-icons';
import { faM } from '@fortawesome/free-solid-svg-icons';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faUsersGear } from '@fortawesome/free-solid-svg-icons';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { faAtom } from '@fortawesome/free-solid-svg-icons';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays as faCalendarDaysRegular } from '@fortawesome/free-regular-svg-icons';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';
import { faTrainSubway } from '@fortawesome/free-solid-svg-icons';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import { faBarsStaggered } from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faGift } from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(faLocation, faImages, faDatabase, faMusic, faLocationDot, faTags, faUser, faTabletScreenButton, faBriefcase, faCity, faM, faMapLocationDot, faCalendarDays, faUsers, faUsersGear, faClipboardList, faCameraRetro, faLayerGroup, faCalendarCheck, faAtom, faGauge, faCalendarDaysRegular, faFileContract, faLaptop, faTrainSubway, faCertificate, faBarsStaggered, faBell, faExclamation, faXmark, faEnvelope, faGift);

const app = createApp({});
app.config.globalProperties.$trans = str => _.get(window.locales, str);

/* add font awesome icon component */
app.component('font-awesome-icon', FontAwesomeIcon);

/* add v-select component */
import 'vue-select/dist/vue-select.css';
// app.component('v-select', vSelect);
/* add Range Slider component */
import FileInput from './elements/FileInput';
app.component('FileInput', FileInput);
import '@vueform/slider/themes/default.css';
import AdminUsersCreateComponent from './components/pages/organizational/AdminUsers/AdminUsersCreateComponent.vue';
import AdminUsersEditComponent from './components/pages/organizational/AdminUsers/AdminUsersEditComponent.vue';
import GroupEditComponent from './components/pages/clients/Group/GroupEditComponent.vue';
import ReportComponent from './components/pages/clients/ReportComponent.vue';
import ReportCreateComponent from './components/pages/clients/Report/ReportCreateComponent.vue';
import DocumentationComponent from './components/pages/documentation/DocumentationComponent.vue';
import DocumentationListDefault from './components/pages/documentation/DocumentationListDefault.vue';
import CreateDocumentationComponent from './components/pages/documentation/CreateDocumentationComponent.vue';
import CreateSoftwareDocumentationComponent from './components/pages/documentation/CreateSoftwareDocumentationComponent.vue';
import CreateVersionDocumentationComponent from './components/pages/documentation/CreateVersionDocumentationComponent.vue';
import CreateReleaseDocumentationComponent from './components/pages/documentation/CreateReleaseDocumentationComponent.vue';
import CreateDocumentDocumentationComponent from './components/pages/documentation/CreateDocumentDocumentationComponent.vue';
import CreatePageDocumentationComponent from './components/pages/documentation/CreatePageDocumentationComponent.vue';
import DocumentationList from './components/pages/documentation/DocumentationList.vue';
import AccessConfiguration from './components/pages/access/AccessConfiguration.vue';
import AccessEditUserSettings from './components/pages/access/AccessEditUserSettings.vue';
import AccessAddUser from './components/pages/access/AccessAddUser.vue';
import AccessRoleList from './components/pages/access/AccessRoleList.vue';
import AccessAddRole from './components/pages/access/AccessAddRole.vue';
import AccessEditRole from './components/pages/access/AccessEditRole.vue';
import AccessAddGroup from './components/pages/access/AccessAddGroup.vue';
import AccessGroupList from './components/pages/access/AccessGroupList.vue';
import AccessUserList from './components/pages/access/AccessUserList.vue';
import ContractEditComponent from './components/pages/documents/Contracts/ContractEditComponent.vue';
import ContractsComponent from './components/pages/documents/Contracts/ContractsComponent.vue';
import ContractCreateComponent from './components/pages/documents/Contracts/ContractCreateComponent.vue';
import ContractAdditionalCreateComponent from './components/pages/documents/Contracts/ContractAdditionalCreateComponent.vue';
import ContractAdditionalEditComponent from './components/pages/documents/Contracts/ContractAdditionalEditComponent.vue';
import AccountingDocumentsComponent from './components/pages/documents/AccountingDocuments/AccountingDocumentsComponent.vue';
import CreateAccountingDocumentsReport from './components/pages/documents/AccountingDocuments/CreateAccountingDocumentsReport.vue';
import CreateAccountingDocumentsReportBy from './components/pages/documents/AccountingDocuments/CreateAccountingDocumentsReportBy.vue';
import DevicesInventoryComponent from './components/pages/inventory/devices/DevicesInventoryComponent.vue';
import HeaderComponentDevicesInventory from './components/HeaderComponentDevicesInventory.vue';
import DeviceStatusHistoryComponent from './components/pages/organizational/Device/DeviceStatusHistoryComponent.vue';
import UserProfileComponent from './components/pages/profile/UserProfileComponent.vue';
import ForgotPasswordComponent from './components/auth/ForgotPasswordComponent.vue';
import LinesComponent from './components/pages/dictionary/Metro/LinesComponent.vue';
import StationComponent from './components/pages/dictionary/Metro/StationComponent.vue';
import CityEditComponent from './components/pages/dictionary/City/CityEditComponent.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import FilterComponent from './elements/FilterComponent.vue';
import ConfirmBtn from './elements/ConfirmBtn.vue';
import '@vuepic/vue-datepicker/dist/main.css'
import SearchDocumentationComponent from "./components/pages/documentation/SearchDocumentationComponent.vue";
import HomeComponent from "./components/pages/HomeComponent.vue";

app.component('Slider', Slider);

app.component('VueDatePicker', VueDatePicker);
app.component('dashboard-component', DashboardComponent);
app.component('report-component', ReportComponent);
app.component('report-create-component', ReportCreateComponent);
app.component('typography-component', TypographyComponent);
app.component('documentation-component', DocumentationComponent);
app.component('search-documentation-component', SearchDocumentationComponent)
app.component('documentation-default-list', DocumentationListDefault);
app.component('create-documentation-component', CreateDocumentationComponent);
app.component('create-software-documentation-component', CreateSoftwareDocumentationComponent);
app.component('create-version-documentation-component', CreateVersionDocumentationComponent);
app.component('create-release-documentation-component', CreateReleaseDocumentationComponent);
app.component('create-document-documentation-component', CreateDocumentDocumentationComponent);
app.component('create-page-documentation-component', CreatePageDocumentationComponent);
app.component('documentation-list', DocumentationList);
app.component('access-configuration', AccessConfiguration);
app.component('access-edit-user-settings', AccessEditUserSettings);
app.component('access-add-user', AccessAddUser);
app.component('access-role-list', AccessRoleList);
app.component('access-add-role', AccessAddRole);
app.component('access-edit-role', AccessEditRole);
app.component('access-add-group', AccessAddGroup);
app.component('access-group-list', AccessGroupList);
app.component('access-user-list', AccessUserList);
app.component('navigation-component', NavigationComponent);
app.component('header-component', HeaderComponent);
app.component('footer-component', FooterComponent);
app.component('client-component', ClientComponent);
app.component('client-edit-component', ClientEditComponent);
app.component('client-create-component', ClientCreateComponent);
app.component('login-component', LoginComponent);
app.component('admin-users-component', AdminUsersComponent);
app.component('gratters-list-component', GrattersListComponent);
app.component('gratters-create-component', GrattersCreateComponent);
app.component('gratters-detail-component', GrattersDetailComponent);
app.component('admin-users-create-component', AdminUsersCreateComponent);
app.component('admin-users-edit-component', AdminUsersEditComponent);
app.component('admin-roles-component', AdminRolesComponent);
app.component('group-right-component', GroupRightComponent);
app.component('organization-component', OrganizationComponent);
app.component('organization-create-component', OrganizationCreateComponent);
app.component('brand-component', BrandComponent);
app.component('brand-create-component', BrandCreateComponent);
app.component('region-component', RegionComponent);
app.component('region-create-component', RegionCreateComponent);
app.component('city-component', CityComponent);
app.component('city-create-component', CityCreateComponent);
app.component('address-component', AddressComponent);
app.component('address-create-component', AddressCreateComponent);
app.component('address-edit-component', AddressEditComponent);
app.component('notifications-component', NotificationsComponent);
app.component('notifications-create-component', NotificationsCreateComponent);
app.component('notifications-edit-component', NotificationsEditComponent);
app.component('device-type-component', DeviceTypeComponent);
app.component('device-type-create-component', DeviceTypeCreateComponent);
app.component('worktime-component', WorktimeComponent);
app.component('worktime-create-component', WorktimeCreateComponent);
app.component('device-component', DeviceComponent);
app.component('device-create-component', DeviceCreateComponent);
app.component('device-edit-component', DeviceEditComponent);
app.component('license-component', LicenseComponent);
app.component('license-create-component', LicenseCreateComponent);
app.component('repository-component', RepositoryComponent);
app.component('repository-create-component', RepositoryCreateComponent);
app.component('content-component', ContentComponent);
app.component('content-create-component', ContentCreateComponent);
app.component('content-table-component', ContentTableComponent);
app.component('content-table-row-component', ContentTableRowComponent);
app.component('content-info-component', ContentInfoComponent);
app.component('playlist-component', PlaylistComponent);
app.component('playlist-create-component', PlaylistCreateComponent);
app.component('playlist-content-component', PlaylistContentComponent);
app.component('playlist-devices-component', PlaylistDevicesComponent);
app.component('group-component', GroupComponent);
app.component('group-create-component', GroupCreateComponent);
app.component('group-edit-component', GroupEditComponent);
app.component('group-device-component', GroupDeviceComponent);
app.component('group-playlist-component', GroupPlaylistComponent);
app.component('organization-edit-component', OrganizationEditComponent);
app.component('content-edit-component', ContentEditComponent);
app.component('playlist-edit-component', PlaylistEditComponent);
app.component('brand-edit-component', BrandEditComponent);
app.component('license-edit-component', LicenseEditComponent);
app.component('notification-component', NotificationComponent);
app.component('notification-detail-component', NotificationDetailComponent);
app.component('letter-constructor-component', LetterConstructorComponent);
app.component('create-account-component', AccountCreateComponent);
app.component('create-accounting-documents-report', CreateAccountingDocumentsReport);
app.component('create-accounting-documents-report-by', CreateAccountingDocumentsReportBy);
app.component('contracts-component', ContractsComponent);
app.component('contract-create-component', ContractCreateComponent);
app.component('contract-additional-create-component', ContractAdditionalCreateComponent);
app.component('contract-edit-component', ContractEditComponent);
app.component('contract-additional-edit-component', ContractAdditionalEditComponent);
app.component('accounting-documents-component', AccountingDocumentsComponent);
app.component('devices-list-client-component', DevicesListClientComponent);
app.component('header-component-devices-inventory', HeaderComponentDevicesInventory);
app.component('devices-inventory-component', DevicesInventoryComponent);
app.component('device-status-history-component', DeviceStatusHistoryComponent);
app.component('user-profile-component', UserProfileComponent);
app.component('forgot-password-component', ForgotPasswordComponent);
app.component('lines-component', LinesComponent);
app.component('station-component', StationComponent);
app.component('city-edit-component', CityEditComponent);
app.component('mailing-add-component', MailingAddComponent)
app.component('mailing-edit-component', MailingEditComponent)
app.component('mailing-registry-component', MailingRegistryComponent)
app.component('recievers-group-add-component', RecieversGroupAddComponent)
app.component('recievers-group-component', RecieversGroupComponent)
app.component('recievers-group-edit-component', RecieversGroupEditComponent)
app.component('template-add-component', TemplateAddComponent)
app.component('template-edit-component', TemplateEditComponent)
app.component('template-registry-component', TemplateRegistryComponent)
app.component('log-component', LogComponent);
app.component('log-hardware-component', LogHardwareComponent);
app.component('log-software-component', LogSoftwareComponent);
app.component('log-install-updates-component', LogInstallUpdatesComponent);
app.component('log-events-component', LogEventsComponent);
app.component('log-schedule-update-component', LogScheduleUpdateComponent);
app.component('log-downloads-updates-component', LogDownloadsUpdatesComponent);
app.component('log-content-update-component', LogContentUpdateComponent);
app.component('senders-component', SendersComponent);
app.component('senders-add-component', SendersAddComponent);
app.component('senders-edit-component', SendersEditComponent);
app.component('version-registry-component', VersionRegistryComponent);
app.component('version-add-component', VersionAddComponent);
app.component('version-edit-component', VersionEditComponent);
app.component('notification-registry-component', NotificationRegistryComponent);
app.component('notification-add-component', NotificationAddComponent);
app.component('notification-edit-component', NotificationEditComponent);
app.component('notification-list-component', NotificationListComponent);
app.component('content-check-component', ContentCheckComponent);
app.component('schedule-component', ScheduleComponent);
app.component('software-update-schedule-component', SoftwareUpdateScheduleComponent);
app.component('content-update-schedule-component', ContentUpdateScheduleComponent);
app.component('add-software-update-schedule-component', AddSoftwareUpdateScheduleComponent);
app.component('edit-software-update-schedule-component', EditSoftwareUpdateScheduleComponent);
app.component('add-content-update-schedule-component', AddContentUpdateScheduleComponent);
app.component('release-registry-component', ReleaseRegistryComponent);
app.component('release-add-component', ReleaseAddComponent);
app.component('release-edit-component', ReleaseEditComponent);
app.component('device-software-component', DeviceSoftwareComponent);
app.component('device-software-create-component', DeviceSoftwareCreateComponent);
app.component('device-software-edit-component', DeviceSoftwareEditComponent);
app.component('filter-component', FilterComponent);
app.component('confirm-btn', ConfirmBtn);
app.component('device-status-component', DeviceStatusComponent);
app.component('home-component', HomeComponent);

app.use(vuetify);
app.use(store);
app.use(globalMethods);

app.mount('#app');
